import { modalWindows as EnUsModalWindows } from '../en-us/modalWindows';
import { AgResourceLanguage } from '../types';

export const modalWindows: AgResourceLanguage['modalWindows'] = {
  ...EnUsModalWindows,
  editShippingMethod: {
    titleHeader: 'Editar Método de Envío',
    subtitle: 'Elige:',
    saveMethodButton: 'Guardar Método de Envío'
  },
  editShippingAddress: {
    bannerText: 'La dirección de envío se cambiará a partir del próximo envío',
    titleHeaderCreate: 'Crear Dirección de Envío',
    subscriptionUpdate: 'Establecer como la dirección de envío para mi suscripción',
    address2: 'Apartamento, Suite, Etc. (opcional)',
    city: 'Ciudad',
    usedSavedLabel: 'Usar dirección guardada',
    zip: 'Código Postal',
    titleAddress: 'Editar Dirección',
    titleHeaderEdit: 'Editar Dirección de Envío',
    last_name: 'Apellido',
    company: 'Empresa (opcional)',
    first_name: 'Nombre',
    phone: 'Teléfono',
    province: 'Provincia',
    deleteAddressText: '¿Estás seguro de que deseas eliminar la dirección guardada?',
    selectAddress: {
      reloadMessage: 'Recarga la página, por favor',
      noSavedAddressText: 'Actualmente no tienes direcciones guardadas',
      useSavedAddressButton: 'Usar dirección guardada',
      noSavedAddressButton: 'No hay direcciones guardadas',
      titleForSelectAddressModal: 'Seleccionar Dirección de Envío',
      cancelButton: 'Cancelar',
      submitButton: 'Ok',
      useSelectButton: 'Usar seleccionado'
    },
    massUpdate: 'Usar para todas las suscripciones activas',
    deleteAddressTitle: 'Eliminar Dirección',
    updateButton: 'Actualizar',
    address1: 'Dirección',
    country: 'País',
    cancelButton: 'Cancelar'
  },
  addPaymentMethod: {
    title: 'Agregar Método de Pago',
    instructions:
      'Se enviará un correo electrónico a {{email}} para añadir tu método de pago de forma segura. Confirma abajo para enviar el correo.'
  },
  editPaymentMethod: {
    title: 'Editar Método de Pago',
    instructions:
      'Se enviará un correo electrónico a {{email}} para editar tu método de pago de forma segura. Confirma abajo para enviar el correo.',
    shopPayInstructions: `Se enviará un correo electrónico a {{email}} para editar de manera segura tu método de pago en Shop Pay. Confirma abajo para enviar el correo electrónico. \n
    Si deseas cambiar el método de pago de Shop Pay a otro método, como PayPal o Apple Pay, por favor cancela tu suscripción volviendo a los detalles de tu suscripción. Una vez cancelada, crea una nueva suscripción e ingresa el método de pago preferido.`
  },
  paymentMethod: {
    cancelButton: 'Cancelar',
    submitButton: 'Enviar Correo Electrónico',
    successTitle: 'Correo de Confirmación Enviado',
    successMessage: 'Pronto recibirás un correo electrónico de confirmación'
  },
  cancelSubscription: {
    keepButton: 'Mantener',
    commentsPlaceholder: 'Describe el problema',
    cancelButton: 'Cancelar Suscripción',
    reasons:
      'No he notado beneficios,Me estoy mudando o viajando,Ya tengo suficiente,Tengo una razón médica,Es muy caro,No me gusta el sabor,No quiero una suscripción,Otra razón',
    v53Reasons: 'No me gusta la nueva fórmula,No me gusta el nuevo sabor tropical',
    agzCancelationReasons:
      'No me gusta el sabor de AGZ,No he notado ningún beneficio de AGZ,Ya tengo más AGZ del que necesito,No quiero una suscripción,Tengo una razón médica,Esto es demasiado caro,Me mudo por motivos de viaje,Otra razón',
    commentsLabel: 'Comentarios',
    keepSubscriptionButton: 'Mantener Suscripción',
    text: 'Confirma la cancelación de tu suscripción a continuación. Si deseas dejar una razón, agradeceríamos tus comentarios para mejorar la experiencia de otros en el futuro (opcional):',
    title: '¡Lamentamos que te vayas!'
  },
  switchProduct: {
    packName: 'Paquetes de Viaje',
    modalTitle: 'Cambiar a {{productName}}',
    title:
      'Tu próximo pedido el {{formatNextOrderDate}} incluirá {{qtyModal}} caja(s) de {{switchToText}}',
    infoMessage: 'El producto solo se cambiará para tu próximo pedido.',
    cancelButton: 'Cancelar',
    confirmButton: 'Confirmar',
    pouchName: 'Paquetes',
    quantityText: 'Cantidad de {{switchToText}} para cambiar:',
    description:
      'Puedes cambiar la cantidad de tu {{switchToText}} en la página de gestión de suscripciones.'
  },
  switchFromFreeShipping: {
    text: 'Tu plan de envío gratuito actual requiere un suministro de 3 meses de AG1 Pouch enviado cada 90 días. Al cambiar el producto a Paquetes de Viaje, el precio volverá a €89 por cada 30 unidades de Paquetes de Viaje y se aplicará un costo de envío de €9 por pedido.'
  },
  skipShipment: {
    textConfirm: 'La próxima fecha de pedido se cambiará a {{date}}',
    skipButton: 'Cancelar',
    questionConfirm: '¿Estás seguro de que deseas omitir el próximo envío?',
    continueButton: 'Continuar',
    headConfirm: 'Omitir Envío'
  },
  acceptAddressValidation: {
    title: 'Confirma tu Dirección',
    continueButton: 'Guardar y Continuar',
    enteredTitle: 'Dirección Introducida',
    editButton: 'Editar Dirección',
    suggestedTitle: 'Dirección Sugerida',
    text: 'No pudimos verificar la dirección exacta que has introducido. Verifica si es correcta o realiza los cambios necesarios.'
  },
  shopAlert: {
    deleteButtonTitle: 'Continuar',
    cancelButtonTitle: 'Cancelar',
    makeGiftCartButtonTitle: 'Como un Regalo',
    subToGift: {
      headerTitle: 'Antes de añadir una suscripción',
      content:
        'Los pedidos de regalo solo pueden contener productos que se envíen una vez. Al añadir una suscripción a tu carrito, se eliminarán los productos de regalo.'
    },
    giftToSub: {
      headerTitle: 'Antes de añadir un regalo',
      content:
        'Los pedidos de suscripción no se pueden enviar con un mensaje de regalo. Al añadir un regalo a tu carrito, se eliminarán los productos de suscripción.'
    },
    giftToOtp: {
      headerTitle: '¿Deseas hacer todo el pedido como un regalo?',
      content:
        'Ya tienes productos de compra única en tu carrito. ¿Deseas hacer todo el pedido como un regalo?'
    }
  },
  addProductFromSlider: {
    toastNextOrder: 'Producto añadido al próximo pedido de ',
    toastSubscription: 'Producto añadido a {{name}}',
    toastSeveralSubscription: 'Producto añadido a',
    severalSubscriptions: 'suscripciones',
    toastToAllSubscription: 'Producto añadido a todas las suscripciones',
    toastToAllNextOrder: 'Producto añadido al próximo pedido de todas las suscripciones',
    titleSubscription: 'Añadir Producto a Suscripción',
    titleNextOrder: 'Añadir Producto al Próximo Pedido',
    checkbox: 'Añadir a todas las suscripciones activas',
    text: 'Selecciona la suscripción a la que deseas añadir el producto.',
    addProductButton: 'Añadir Producto'
  },
  cart: {
    subscriptionTitle: 'Suscripción',
    title: 'Tu Carrito',
    checkoutButtonLabel: 'Pagar',
    summary: {
      taxEstimatedLabel: 'Impuesto Estimado',
      taxLabel: 'Impuesto',
      totalLabel: 'Total',
      taxNotReady: '---',
      shippingLabel: 'Envío',
      discountLabel: 'Tu descuento',
      freePrice: 'Gratis',
      subtotalLabel: 'Subtotal'
    },
    emptyState: {
      oneTimeProductsTitle: 'Favoritos de los Miembros',
      addOneTimeProductButton: 'Añadir al Carrito',
      label: 'Añade artículos a tu carrito'
    },
    emptyStateLabel: 'Añade artículos a tu carrito',
    frequencyLabel: 'Enviado cada 30 días',
    promoCode: {
      promoCTA: '¿Tienes un código promocional?',
      promoError: 'Código promocional no válido',
      promoInputLabel: 'Código promocional',
      promoButtonLabel: 'Aplicar'
    }
  },
  changeOrderDate: {
    title: 'Seleccionar Fecha de Pedido',
    confirmButton: 'Confirmar',
    nextOrderDateSuccessText: 'Tu próxima fecha de pedido es {{date}}.',
    nextOrderDateChangeText:
      'La próxima fecha de pedido para esta suscripción se cambiará a {{date}} ',
    description: 'Puedes cambiar la fecha de tu próximo pedido',
    newDateChangeText: 'La nueva fecha de pedido es',
    newDateSuccessText: 'La próxima fecha de pedido ha sido cambiada a {{date}} '
  },
  shipNow: {
    shipNowButton: 'Confirmar Pedido',
    subtitle: 'Pedido realizado con éxito',
    description:
      'Este pedido se enviará dentro de las 24 horas hábiles posteriores al pago. Ten en cuenta que los fines de semana y festivos pueden tardar hasta 48 horas. Tu próximo pedido se realizará en {{shipInterval}} el {{date}}',
    title: 'Enviar el Próximo Pedido Ahora',
    confirm:
      'Al confirmar abajo, tu pedido será procesado dentro de 1 día hábil. Ten en cuenta que los fines de semana y festivos pueden tardar hasta 48 horas.',
    preparing: 'Preparando',
    preparingDescription: 'Tienes un pedido actual estimado para enviar',
    shipped: 'Enviado',
    shippedDescription: 'Tienes un pedido actual que ha sido enviado',
    delivered: 'Entregado',
    deliveredDescription: 'Tu último pedido fue entregado',
    shipNext: 'Enviar siguiente pedido ahora:',
    nextOrder: 'Próximo pedido:',
    followedBy: 'Seguido de:'
  },
  editFrequency: {
    titleView: 'Editar Frecuencia de Envío',
    titleDatepicker: 'Cambiar Próxima Fecha de Pedido',
    day: 'Día',
    infoMessage: 'La frecuencia de envío ha sido cambiada a {{date}}.',
    shippingFrequency: 'Frecuencia de Envío',
    item: 'Cada',
    nextOrderButton: 'Próxima Fecha de Pedido',
    nextOrderLink: 'Cambiar próxima fecha de pedido',
    nextOrder: 'Próximo pedido:',
    followedBy: 'Seguido de:',
    description: 'Los cambios entrarán en vigor a partir de tu próxima fecha de pedido.',
    followingText: 'seguido de',
    ribbonMessage:
      'Este cambio solo se aplica a los pedidos <bold>{{followingText}}</bold> después de tu próxima fecha de pedido.',
    extraInfo:
      'Al confirmar abajo, se te cobrará hoy y el pedido será enviado dentro de 1 día hábil. Ten en cuenta que los fines de semana y festivos pueden tardar hasta 48 horas.',
    saveButton: 'Guardar Cambios',
    confirmButton: 'Confirmar'
  },
  acceptChanges: {
    text: 'Actualizar la información de tu suscripción restablecerá tu próximo pedido y eliminará los artículos "únicos".',
    title: 'Antes de Cambiar tu Suscripción',
    continueButton: 'Continuar',
    cancelButton: 'Cancelar'
  },
  acceptFreeShippingChanges: {
    text: 'Tu plan de envío gratuito actual requiere un suministro de 3 meses de producto, enviado cada 90 días. Al cambiar la cantidad, el precio volverá a €79 por bolsa y se aplicará un costo de envío de €9 por pedido.',
    title: 'Antes de Cambiar tu Suscripción',
    continueButton: 'Continuar',
    cancelButton: 'Cancelar',
    successMessage: 'Tu suscripción ahora es de €79 por bolsa con un costo de envío de €9'
  },
  activateSubscription: {
    successTitle: 'Tu suscripción {{name}} está activa y lista para gestionar.',
    errorMessage: 'No se puede cambiar la fecha del pedido',
    activateButton: 'Activar Suscripción',
    title: 'Reactivar Suscripción',
    infoMessage:
      'Puedes cambiar la fecha de tu próximo pedido antes de que tu suscripción sea activada',
    successDescription: 'El próximo día de pedido es {{date}}.'
  },
  addProductFromModal: {
    noteTitle: 'How to swap from AG1 Pouch to AG1 30 Ct Travel Packs',
    noteSubtitle:
      'To swap between Pouch and 30 Ct Travel Packs, add the desired product to your subscription by selecting “Add to Subscription”. Once added, remove the other product from your subscription by selecting the trash can icon on your Subscription Details page.',
    addToOrder: 'Añadir Producto al Pedido',
    addToSubscription: 'Añadir a la Suscripción',
    addToNextOrder: 'Añadir al Próximo Pedido',
    addedToNextOrder: 'Añadido al Próximo Pedido',
    addedToSubscription: 'Añadido a la Suscripción',
    preferredFlavorText: 'Member preferred flavor'
  }
};
